export default {
    admin: {
        liftbox: {
            exists: {
                title: "Liftbox existiert bereits",
                message: "Die Liftbox mit der EID {0} existiert bereits bei der Anlage {1} für den Kunden {2}. Die Anlage kann daher nicht erneut eingerichtet werden."
            },
            capture: {
                none: "keine",
                gatewayerror: {
                    title: "Liftbox Registrierung",
                    message: "Das Gateway <span class='error--text'>{0}</span> konnte nicht registriert werden.<br><br>Aflex API Meldung:<br><span class='error--text'>{1}</span>"
                },
                result: {
                    title: "Liftbox Registrierung",
                    message: "Das Gateway <span class='success--text'>{0}</span> wurde erfolgreich registriert.<br><br>Folgende Sensoren wurden registriert<br><span class='success--text'>{1}</span><br><br>Folgende Sensoren sind bereits registriert:<br><span class='error--text'>{2}</span><br><br>Folgende Sensoren konnten nicht registriert werden:<br><span class='error--text'>{3}</span>"
                },
            },
        },
    },

    lgsmart: {
        pairTime  : "verbunden seit",
        notMounted: "LG Smart nicht vorhanden",
        noData    : "Keine Liftbox-Daten verfügbar",
        refresh   : "Liftbox-Status neu laden",
        firmware  : "Firmware",
        since     : "seit",

        state: {
            ok: "in Ordnung",
            POWER_LOST         : "Stromversorgung unterbrochen",
            HIGH_DELAY         : "Hohe Verzögerung",
            OFFLINE            : "Offline",
            UNKNOWN            : "Unbekannt",
            SENSOR_LOW_BATTERY : "Batterie schwach",
            SENSOR_DISCONNECTED: "Sensor getrennt"
        },

        sensor: {
            GATEWAY: {
                title: "Gateway auf dem Fahrkorbdach",
                name : "Gateway"
            },
            DOOR_1: {
                title: "Sensor Fahrkorbtür 1",
                name : "Fahrkorbtür 1"
            },
            DOOR_2: {
                title: "Sensor Fahrkorbtür 2",
                name : "Fahrkorbtür 2"
            },
            REFERENCE: {
                title: "Sensor Hauptzugangsebene",
                name : "Hauptzugangsebene"
            },
            deleted: "Das Bild zum Sensor wurde gelöscht!",
            noimage: "Keine Aufnahme",
            inuse  : "Sensor wird bereits verwendet ({0})",
            location: "Lage des Sensors"
        },
        assembly: {
            title       : "Montage",
            unusableDoor: "Keine Türmontage möglich",
            noSecondDoor: "Durchladung/Übereckdeckung"
        },

        success: "Die Änderungen wurde im Dashboard übernommen",
        command: {
            title  : "<span style='color:red'>Anlage kann nicht mit dem Dashboard synchronisiert werden</span>",
            message: "Verarbeitung wurde wegen eines unbekannten Auftrags abgebrochen",
        },
        customer: {
            unknown: {
                title  : "<span style='color:red'>Anlage kann nicht ins Dashboard übernommen werden</span>",
                message: "Die Anlage kann nicht in das Dashboard übernommen werden, weil der Kunde noch nicht für das Dashboard zugelassen wurde."
            }
        },

        unit: {
            unknown   : {
                title  : "<span style='color:red'>Anlage kann nicht aus dem Dashboard entfernt werden</span>",
                message: "Die Anlage wurde noch nicht im Dashboard registriert."
            },
            onboarding: {
                title  : "<span style='color:red'>Anlage kann nicht aus dem Dashboard entfernt werden</span>",
                message: "Die Anlage ist bereits für die Montage eingeplant und kann daher nicht aus dem Dashboard entfernt werden."
            }
        }
    },
}